import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Maak Supabase optioneel - retourneer null als variabelen ontbreken
export const supabase: SupabaseClient | null = (supabaseUrl && supabaseAnonKey) 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

// Types voor de database
export type Strippenkaart = {
  id: string;
  user_id: string;
  resterende_strippen: number;
  totaal_strippen: number;
  gekocht_op: string;
  archived: boolean;
};

export type EventRegistration = {
  id: string;
  user_id: string;
  event_id: string;
  event_datum: string;
  event_tijd: string;
  event_locatie: string;
  rol: 'representant' | 'vraagsteller';
  strippenkaart_id: string | null;
  checkout_session_id: string | null;
  aangemeld_op: string;
  status: 'bevestigd' | 'geannuleerd' | 'aanwezig';
};

export type Database = {
  public: {
    Tables: {
      strippenkaarten: {
        Row: Strippenkaart;
        Insert: Omit<Strippenkaart, 'id' | 'gekocht_op'>;
        Update: Partial<Omit<Strippenkaart, 'id' | 'gekocht_op'>>;
      };
      event_registrations: {
        Row: EventRegistration;
        Insert: Omit<EventRegistration, 'id' | 'aangemeld_op'>;
        Update: Partial<Omit<EventRegistration, 'id' | 'aangemeld_op'>>;
      };
    };
  };
};

